<div class="d-flex flex-column h-100">
    <!-- Call Desc & Call Info Container -->
    <div>
        <div class="ps-0">
            <div class="pt-1 pb-1 ps-0 text-secondary font-xs">
                {{ callDescription() }}
            </div>
        </div>
        <div
            class="call-details ps-0 pt-1 mb-0"
            [ngClass]="{
                highlighted:
                    panelHighlighted() === 'main' &&
                    !voiceStore.activeVoiceTaskOnHold().onHold,
            }"
        >
            <div class="pt-1 p-2 pb-1">
                <voice-call-info
                    [conversation]="conversation()"
                    [workitem]="workItem()"
                    [customerName]="customerName()"
                    [agentName]="agentName()"
                    [callTime]="callTime() | formatDuration"
                    [hold]="voiceStore.activeVoiceTaskOnHold().onHold"
                    (callEnd)="endCall()"
                ></voice-call-info>
            </div>
        </div>
    </div>

    @if (voiceStore.hasVoiceTask()?.actions?.enableDTMFKeypad) {
        <div class="voice-call__dialpad dialpad mt-4">
            <div class="col-12">
                <div class="d-flex flex-column">
                    <div
                        class="pt-3 d-flex flex-row justify-content-between align-items-center ms-1 me-1"
                    >
                        <div class="d-flex flex-row align-items-center">
                            <i
                                class="fa-xl fa-solid fa-grid-round dialpad-icon me-3"
                            ></i>
                            <div class="text-primary font-xs">Key Pad</div>
                        </div>
                        <button
                            type="button"
                            aria-label="Close"
                            class="btn-close text-reset btn-tiny"
                            (click)="voiceStore.toggleDTMFKeypad()"
                        ></button>
                    </div>
                    <div class="pt-4 pb-4">
                        <telxl-dialpad
                            (buttonClick)="dialpadClick($event)"
                        ></telxl-dialpad>
                    </div>
                </div>
            </div>
        </div>
    } @else {
        <div class="voice-call__action-buttons">
            <div class="d-flex h-100 justify-content-between flex-wrap">
                <voice-call-button
                    class="voice-call__priority-buttons--padding-right voice-call__priority-buttons--full-width"
                    icon="fa-microphone-slash"
                    iconSelected="fa-microphone"
                    title="Mute"
                    titleSelected="Unmute"
                    [isClickedInput]="voiceStore.hasVoiceTask()?.actions?.muted"
                    (buttonClicked)="voiceStore.toggleMuteButton()"
                    [disabled]="false"
                ></voice-call-button>
                <voice-call-button
                    class="voice-call__priority-buttons--padding-left voice-call__priority-buttons--full-width"
                    icon="fa-circle-pause"
                    iconSelected="fa-circle-pause"
                    title="Hold"
                    titleSelected="On Hold"
                    [isClickedInput]="opOnHold()"
                    (buttonClicked)="toggleHoldButton()"
                    [disabled]="holdButtonDisabled()"
                ></voice-call-button>

                <voice-call-button
                    class="voice-call__action-button p-0"
                    icon="fa-magnifying-glass-arrow-right"
                    iconSelected="fa-magnifying-glass-arrow-right"
                    title="Enquiry"
                    titleSelected="Enquiry"
                    [isClickedInput]="enquiry() && displayContacts()"
                    (buttonClicked)="btnClicked($event)"
                    [disabled]="enquiryDisabled()"
                ></voice-call-button>
                <voice-call-button
                    class="voice-call__action-button p-0"
                    icon="fa-arrow-right-arrow-left"
                    iconSelected="fa-arrow-right-arrow-left"
                    title="Transfer"
                    titleSelected="Transfer"
                    [isClickedInput]="transfer() && displayContacts()"
                    (buttonClicked)="btnClicked($event)"
                    [disabled]="transferDisabled()"
                ></voice-call-button>
                @if (voiceStore.paymentsEnabled()) {
                    <voice-call-button
                        class="voice-call__action-button p-0"
                        icon="fa-light fa-credit-card"
                        iconSelected="fa-solid fa-credit-card"
                        title="Payments"
                        [isClickedInput]="
                            voiceStore.hasVoiceTask()?.actions?.enablePayments
                        "
                        titleSelected="Payments"
                        (buttonClicked)="voiceStore.togglePayments()"
                        [disabled]="
                            !!workItem()?.isEnquiryCall ||
                            !!this.conversation()?.isInternalCall
                        "
                    ></voice-call-button>
                }
                <voice-call-button
                    class="voice-call__action-button p-0"
                    icon="fa-arrow-turn-left"
                    iconSelected="fa-arrow-turn-left"
                    title="Return to IVR"
                    titleSelected="Return to IVR"
                    [isClickedInput]="ivr() && displayContacts()"
                    (buttonClicked)="btnClicked($event)"
                    [disabled]="ivrDisabled()"
                ></voice-call-button>
                <voice-call-button
                    class="voice-call__action-button p-0"
                    icon="fa-grid-round"
                    iconSelected="fa-grid-round"
                    title="DTMF Keypad"
                    titleSelected="DTMF Keypad"
                    [isClickedInput]="
                        voiceStore.hasVoiceTask()?.actions?.enableDTMFKeypad
                    "
                    (buttonClicked)="voiceStore.toggleDTMFKeypad()"
                    [disabled]="workItem()?.isEnquiryCall ?? false"
                ></voice-call-button>
            </div>
        </div>
    }
</div>
